export function getEnergietraegerKeyMap(): any {
    // vKey = Verbrauch Key; kKey = Kosten Key;
    const map: any = {
        // Strom, extractEnergieStrom()
        'strom': { name: 'Strom', vKey: 'verbrauch_strom', kKey: 'kosten_strom' },
        // Wärme, entity_energiedaten_waerme_energietraeger, extractEnergieWaermeNeu()
        'fernwaerme': { name: 'Fernwärme', grp: 'Wärme' },
        'fernkaelte': { name: 'Fernkälte', grp: 'Wärme' },
        'andere': { name: 'Sonstige Wärmeträger', grp: 'Wärme' },
        'erdgas': { name: 'Erdgas', grp: 'Wärme' },
        'fluessiggas': { name: 'Flüssiggas', grp: 'Wärme' },
        'bio_brennholz': { name: 'Biomasse - Brennholz', grp: 'Wärme' },
        'bio_hackschnitzel': { name: 'Biomasse - Hackschnitzel', grp: 'Wärme' },
        'bio_holzpellets': { name: 'Biomasse - Pellets', grp: 'Wärme' },
        'hel': { name: 'Heizöl', grp: 'Wärme' },
        'steinkohle': { name: 'Kohle - Steinkohle', grp: 'Wärme' },
        'braunkohle': { name: 'Kohle - Braunkohle', grp: 'Wärme' },
        // Kraftstoff, entity_energiedaten_kraftstoff_energietraeger, extractEnergieKraftstoffe()
        'benzin': { name: 'Benzin [Liter]', name2: 'Benzin', grp: 'Kraftstoff', vKey: 'benzin_verbrauch', kKey: 'benzin_kosten' },
        'diesel': { name: 'Diesel [Liter]', name2: 'Diesel', grp: 'Kraftstoff', vKey: 'diesel_verbrauch', kKey: 'diesel_kosten' },
        'lpg': { name: 'LPG [Liter]', name2: 'LPG', grp: 'Kraftstoff', vKey: 'lpg_verbrauch', kKey: 'lpg_kosten' },
        'ladestrom': { name: 'Ladestrom [kWh]', name2: 'Ladestrom', grp: 'Kraftstoff', vKey: 'ladestrom_verbrauch', kKey: 'ladestrom_kosten' },
        'wasserstoff_kwh': { name: 'Wasserstoff [kWh]', name2: 'Wasserstoff', grp: 'Kraftstoff', vKey: 'wasserstoff_kwh_verbrauch', kKey: 'wasserstoff_kwh_kosten' },
        'wasserstoff_kg': { name: 'Wasserstoff [kg]', name2: 'Wasserstoff', grp: 'Kraftstoff', vKey: 'wasserstoff_kg_verbrauch', kKey: 'wasserstoff_kg_kosten', },
        'erdgas_kwh': { name: 'Erdgas [kWh]', name2: 'Erdgas', grp: 'Kraftstoff', vKey: 'erdgas_kwh_verbrauch', kKey: 'erdgas_kwh_kosten' },
        'erdgas_cng_kg': { name: 'Erdgas - CNG [kg]', name2: 'Erdgas - CNG', grp: 'Kraftstoff', vKey: 'erdgas_cng_kg_verbrauch', kKey: 'erdgas_cng_kg_kosten' },
        'erdgas_lng_kg': { name: 'Erdgas - LNG [kg]', name2: 'Erdgas - LNG', grp: 'Kraftstoff', vKey: 'erdgas_lng_kg_verbrauch', kKey: 'erdgas_lng_kg_kosten' },
        'biogas': { name: 'Biogas', grp: 'Wärme' },
        'biodiesel': { name: 'Biodiesel', grp: 'Kraftstoff', vKey: 'biodiesel_verbrauch', kKey: 'biodiesel_kosten' },
        'bioethanol': { name: 'Bioethanol', grp: 'Kraftstoff', vKey: 'bioethanol_verbrauch', kKey: 'bioethanol_kosten' },
    };

    Object.keys(map).forEach((key: string) => {
        if (map[key].grp === 'Wärme') {
            map[key].vKey = `verbrauch_waerme_${key}_kwh`;
            map[key].kKey = `kosten_waerme_${key}`;
        }
    });

    return map;
}
